<template>
  <div
    :id="poi.id"
    class="v-card__container"
    @mouseenter="hoverPoi"
    @mouseleave="leaverHoverPoi"
  >
    <FavoriteButton :poi="poi"/>
    <v-card
      :rounded="false"
      :flat="true"
      :to="link"
      min-height="300"
      max-height="300"
    >
      <v-img
        height="140"
        :title="true"
        :lazy-src="lazyImage"
        :src="coverImage"
      />

      <v-card-subtitle>
        {{ subtitle }}
        <HotelStars
          :poi="poi"
          :small="true"
        />
      </v-card-subtitle>
      <v-card-title>{{ name }}</v-card-title>
      <v-card-text>{{ address }}</v-card-text>
    </v-card>
  </div>
</template>

<script>
  import FavoriteButton from '../favorites/FavoriteButton.vue'
  import HotelStars from '../common/HotelStars.vue'

  export default {
    name: 'ResultThumbnail',

    props: {
      poi: {
        required: true,
      },
    },

    components: {
      FavoriteButton,
      HotelStars,
    },

    computed: {
      locale() {
        return this.$store.state.locale
      },

      lazyImage() {
        return this.poi.image && this.poi.image.lazy || this.$store.state.objects.defaultImages.lazy
      },

      coverImage() {
        return this.poi.image && this.poi.image.cover || this.$store.state.objects.defaultImages.cover
      },

      name() {
        const { name } = this.poi.business_content[this.locale]
        if (name && name.length > 45) return `${name.slice(0, 45)}...`

        return name
      },

      link() {
        const { poi, locale } = this
        return { name: 'DetailPage', params: { locale, slug: poi.slug[locale] } }
      },

      subtitle() {
        return this.$tc(`categories.${this.poi.venue_finder_sub_category}`, 1)
      },

      address() {
        const location = this.poi.geolocations[0]
        if (!location) return null

        const { address, zip, city } = location

        if (!address && !zip && !city) return null

        return `${address || ''}, ${zip || ''} ${city || ''}`
      },
    },

    methods: {
      hoverPoi() {
        this.$emit('hoverEnter', this.poi.id)
      },

      leaverHoverPoi() {
        this.$emit('hoverLeave')
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/_config.sass"

  .theme--light.v-card
    background-color: $ternary-color

  .theme--light.v-card .v-card__subtitle
    color: #fff

  .v-sheet.v-card
    border-radius: 0

  .v-card

    &__container
      position: relative

    &__title
      padding-top: 5px
      display: block
      text-align: center
      font-size: 17.5px
      font-family: "EuclidBold"
      word-break: unset

    &__subtitle
      padding-bottom: 0
      font-size: 15.4px
      text-align: center
      font-family: "EuclidMedium"

    &__text
      font-family: "EuclidBold"
      font-size: 11.2px
      text-align: center

</style>
